import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import React from "react";

export default function P220Info({data,setDialog, setDialogAlert}) {
    
    return (
        <>
            <div className="p-grid crud-demo">
                <div className="p-col-12">
                    {/* <div className="card"> */}
                    <div className="p-grid p-fluid" style={{ marginTop: "10px" }}>
                        <div className="p-col-12 p-md-1"></div>
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="inspectTime">ช่วงเวลาดำเนินการ</label>
                            <InputText
                                type="text"
                                placeholder="ช่วงเวลาดำเนินการ"
                                value={data.operateDateBegin}
                                disabled 
                            />
                        </div>
                        
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="inspectTime">ถึง</label>
                            <InputText
                                type="text"
                                placeholder="ถึง"
                                value={data.operateDateEnd}
                                disabled   
                            />
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="inspectTime">ส่งงานทั้งหมด</label>
                            <InputText
                                type="text"
                                placeholder="ส่งงานทั้งหมด"
                                value={data.totalDeliver}
                                disabled 
                            />
                        </div>
                        <div className="p-col-12 p-md-2">
                            <Button
                                className="p-button p-button-warning btn-srh-responsive"
                                icon="fas fa-file-alt"
                                label="รายละเอียด"
                                style={{ display: 'flex',marginBottom : '10px',marginTop: 25 }}
                                onClick={() => {setDialog({dialog:true}) }}
                                //221 
                            />
                        </div>
                    </div>
                    
                    <div className="p-grid p-fluid" style={{ marginBottom: "0px" }}>
                        <div className="p-col-12 p-md-1"></div>
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="inspectTime">จำนวนงานสั่งการเฉพาะอย่าง</label>
                            <InputText
                                type="text"
                                placeholder="จำนวนงานสั่งการเฉพาะอย่าง"
                                value={data.totalOrder}
                                disabled 
                            />
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="inspectTime">คงค้าง</label>
                            <InputText
                                type="text"
                                placeholder="คงค้าง"
                                value={data.pendingOrder}
                                disabled 
                            />
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="inspectTime">เสร็จภายในกำหนด</label>
                            <InputText
                                type="text"
                                placeholder="เสร็จภายในกำหนด"
                                value={data.inTimeOrder}
                                disabled 
                            />
                        </div>
                    </div>

                    <div className="p-grid p-fluid" style={{ marginBottom: "0px" }}>
                        <div className="p-col-12 p-md-3">
                            
                        </div>
                        <div className="p-col-12 p-md-1"></div>
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="inspectTime">เสร็จเกินกำหนด</label>
                            <InputText
                                type="text"
                                placeholder="เสร็จเกินกำหนด"
                                value={data.overDueOrder}
                                disabled 
                            />
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label htmlFor="inspectTime">แจ้งเตือน</label>
                            <InputText
                                type="text"
                                placeholder="แจ้งเตือน"
                                value={data.warningLetter}
                                disabled 
                            />
                        </div>
                        <div className="p-col-12 p-md-2">
                            <Button
                                className="p-button p-button-warning btn-srh-responsive"
                                icon="fas fa-file-alt"
                                label="รายละเอียด"
                                style={{ display: 'flex',marginBottom : '10px',marginTop: 25 }}
                                onClick={() => {setDialogAlert({dialog:true}) }}
                                //222 
                            />
                        </div>
                    </div>

                    <div className="p-grid p-fluid" style={{ marginBottom: "0px" }}>
                        <div className="p-col-12 p-md-1"></div>
                        <div className="p-col-12 p-md-9">
                            <hr/>
                            <label htmlFor="inspectTime">ผลการตรวจงาน</label>
                        </div>
                    </div>
                    

                    <div className="p-grid p-fluid" style={{ marginBottom: "0px" }}>
                        <div className="p-col-12 p-md-1"></div>
                        <div className="p-col-12 p-md-4">
                            <label htmlFor="inspectTime">ไม่พบผู้ปฏิบัติงาน</label>
                            <InputText
                                type="text"
                                placeholder="ไม่พบผู้ปฏิบัติงาน"
                                value={data.inspectWorkerResult}
                                disabled 
                            />
                        </div>
                        <div className="p-col-12 p-md-1"></div>
                        <div className="p-col-12 p-md-4">
                            <label htmlFor="inspectTime">เครื่องจักร/เครื่องมือปรับปรุงแก้ไข</label>
                            <InputText
                                type="text"
                                placeholder="เครื่องจักร/เครื่องมือปรับปรุงแก้ไข"
                                value={data.inspectEquipmentResult}
                                disabled 
                            />
                        </div>
                        <div className="p-col-12 p-md-1"></div>
                        
                    </div>
                </div>
            </div>
        </>
    );
}
